import type { AgreementData } from './types';
import type { AgreementDocument } from 'api/agreement/types';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AgreementData = {
  isLoaded: false,
  isApproved: false,
  agreements: [],
};

const agreementSlice = createSlice({
  name: 'agreement',
  initialState,
  reducers: {
    setAgreementDataResult(
      state,
      action: PayloadAction<AgreementDocument[] | undefined>,
    ) {
      const agreements = action.payload;
      const isApproved = !agreements?.some((a) => !a.signed);
      state.isApproved = isApproved;
      state.agreements = agreements?.map(decodeBase64Agreement);
      state.isLoaded = true;
    },
    setIsApproved(state) {
      state.isApproved = true;
    },
  },
});

export const { setAgreementDataResult, setIsApproved } = agreementSlice.actions;

export const agreementReducer = agreementSlice.reducer;

function decodeBase64Agreement(agreement: AgreementDocument) {
  return {
    ...agreement,
    content: atob(agreement.content),
  };
}
